import { render, staticRenderFns } from "./Boost.vue?vue&type=template&id=8d65c682&scoped=true&"
import script from "./Boost.vue?vue&type=script&lang=ts&"
export * from "./Boost.vue?vue&type=script&lang=ts&"
import style0 from "./Boost.vue?vue&type=style&index=0&id=8d65c682&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d65c682",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VContainer,VDialog})
